export const ACCENTCOLOR = "#232323";
export const buttonTextColor = "#21FF91";
export const ACCENTDARKCOLOR = "#21FF91";

export const BACKGROUNDCOLOR = "#f5f5f5";
export const LINKHOVERBACKGROUND = "#e2f3ff";
export const AUTHSIDEBARGRADIENT = "linear-gradient(to top, #202020, #6a6a6a)";
export const LINKCOLOR = "#202020";
export const WHITE = "#fff";
export const PRIMARYCOLOR = "#202020";
export const SECONDARYCOLOR = "#747474";
export const SUCCESS = "#0F9D58";
export const DANGER = "#D64747";
export const WARNING = "#f4a63b";
export const SUCCESSDARKCOLOR = "#008B47";
export const DANGERDARKCOLOR = "#B6393A";
export const BORDERCOLOR = "rgba(112, 112, 112, 0.2)";
export const DISABLEDCOLOR = "rgba(147, 147, 147, 0.1)";
export const GRAY = "#747474";
export const DISABLEDCOLORDARK = "#969696";
export const BLACKCOLOR = "#000000";
export const BLUEBACKGROUNDCOLOR = "#3272EC";

export const primaryButtonStyle = {
  borderRadius: "8px",
  backgroundColor: ACCENTCOLOR,
  buttonTextColor: buttonTextColor,
  border: 0,
};

export const submitButtonStyle = {
  borderRadius: "8px",
  backgroundColor: ACCENTCOLOR,
  buttonTextColor: buttonTextColor,
  border: 0,
};
export const primaryButtonHoverStyle = {
  borderRadius: "8px",
  // buttonTextColor: ACCENTCOLOR,
  buttonTextColor: WHITE,
  backgroundColor: ACCENTCOLOR,
  // backgroundColor: "#21ff91",
  border: 0,
};

export const submitButtonHoverStyle = {
  borderRadius: "8px",
  backgroundColor: GRAY,
  buttonTextColor: WHITE,
  border: 0,
};

export const borderButtonStyle = {
  borderRadius: "8px",
  buttonTextColor: "#232323",
  background: "transparent",
  border: `2px solid ${ACCENTCOLOR}`,
};

export const borderButtonHoverStyle = {
  borderRadius: "8px",
  buttonTextColor: ACCENTCOLOR,
  background: "#232323",
  border: `2px solid ${ACCENTCOLOR}`,
};

export const cancelButtonStyle = {
  borderRadius: "8px",
  boxShadow: "none",
  buttonTextColor: "#16B265",
  background: "#D5FFEA",
  border: `2px solid ${"#D5FFEA"}`,
};
export const cancelButtonHoverStyle = {
  borderRadius: "8px",
  boxShadow: "none",
  buttonTextColor: "#16B265",
  background: "#D5FFEA",
  border: `2px solid ${"#D5FFEA"}`,
};

export const successButtonStyle = {
  borderRadius: "8px",
  backgroundColor: SUCCESS,
  buttonTextColor: WHITE,
  border: 0,
};
export const successButtonHoverStyle = {
  borderRadius: "8px",
  backgroundColor: SUCCESSDARKCOLOR,
  buttonTextColor: WHITE,
  border: 0,
};
export const dangerButtonStyle = {
  borderRadius: "8px",
  backgroundColor: DANGER,
  buttonTextColor: WHITE,
  border: 0,
};
export const blueHoverButtonStyle = {
  borderRadius: "8px",
  backgroundColor: "#232323",
  buttonTextColor: "#21ff91",
  border: 0,
};
export const dangerButtonHoverStyle = {
  borderRadius: "8px",
  backgroundColor: DANGERDARKCOLOR,
  buttonTextColor: WHITE,
  border: 0,
};

export const disabledButtonStyle = {
  borderRadius: "8px",
  backgroundColor: DISABLEDCOLOR,
  buttonTextColor: PRIMARYCOLOR,
  border: `2px solid ${DISABLEDCOLORDARK}`,
};

//For popups in zpin flow and demo center exclusively
export const submitButtonStylePopup = {
  borderRadius: "8px",
  backgroundColor: ACCENTCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
};

export const submitButtonHoverStylePopup = {
  borderRadius: "8px",
  backgroundColor: ACCENTDARKCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
};

export const primaryButtonStylePopup = {
  borderRadius: "8px",
  backgroundColor: ACCENTCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
  minWidth: "190px",
  fontFamily: "'Poppins' sans-serif",
  fontWeight: "500",
};

export const primaryButtonHoverStylePopup = {
  borderRadius: "8px",
  backgroundColor: ACCENTDARKCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
  minWidth: "190px",
  fontFamily: "'Poppins' sans-serif",
  fontWeight: "500",
};

export const disabledButtonStylePopup = {
  borderRadius: "8px",
  backgroundColor: ACCENTCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
  minWidth: "190px",
};

export const disabledButtonHoverStylePopup = {
  borderRadius: "8px",
  backgroundColor: ACCENTDARKCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
  minWidth: "190px",
};

export const disabledButtonStyleOkyc = {
  borderRadius: "8px",
  outline: "none",
  backgroundColor: ACCENTDARKCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
  minWidth: "130px",
  minHeight: "44px",
  cursor: "not-allowed",
};

export const disabledButtonHoverStyleOkyc = {
  borderRadius: "8px",
  outline: "none",
  backgroundColor: ACCENTDARKCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
  minWidth: "130px",
  minHeight: "44px",
  cursor: "not-allowed",
};

export const primaryButtonStyleOkyc = {
  borderRadius: "8px",
  outline: "none",
  backgroundColor: ACCENTCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
  minWidth: "100px",
  minHeight: "44px",
  fontFamily: "'Poppins' sans-serif",
  fontWeight: "500",
};

export const primaryButtonHoverStyleOkyc = {
  outline: "none",
  borderRadius: "8px",
  backgroundColor: ACCENTDARKCOLOR,
  buttonTextColor: WHITE,
  border: 0,
  marginBottom: "20px",
  minWidth: "130px",
  fontFamily: "'Poppins' sans-serif",
  fontWeight: "500",
  minHeight: "44px",
};

export const linkButtonStyleReport = {
  borderRadius: "14px",
  backgroundColor: "transparent",
  fontFamily: "'Outfit'",
  outline: "none",
  border: 0,
};

export const linkButtonHoverStyleReport = {
  borderRadius: "14px",
  backgroundColor: "transparent",
  fontFamily: "'Outfit'",
  outline: "none",
  border: 0,
};

export const primaryButtonStyleReport = {
  borderRadius: "8px",
  gap: "10px",
  height: "34px",
  width: "160px",
  backgroundColor: ACCENTCOLOR,
  buttonTextColor: WHITE,
  border: 0,
};

export const primaryButtonHoverStyleReport = {
  borderRadius: "8px",
  height: "34px",
  width: "160px",
  backgroundColor: ACCENTCOLOR,
  // buttonTextColor: "#21FF91",
  buttonTextColor: WHITE,
  border: 0,
};
